"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var mobx_react_1 = require("mobx-react");
var api_1 = __importStar(require("api"));
var config_1 = __importDefault(require("config"));
var use_stores_1 = require("hooks/use-stores");
var use_dialog_1 = require("hooks/use-dialog");
var EditProductSpecsItem_1 = __importDefault(require("./EditProductSpecsItem"));
var SelectWithNewEntry_1 = __importDefault(require("components/common/inputs/SelectWithNewEntry"));
var AddButton_1 = __importDefault(require("components/common/buttons/AddButton"));
var Dialog_1 = require("components/Dialog");
var close_icon_svg_1 = __importDefault(require("res/img/close-icon.svg"));
var Notification_1 = require("../../../Notification");
var use_notification_1 = require("../../../../hooks/use-notification");
var help_icon_svg_1 = __importDefault(require("../../../../res/img/help-icon.svg"));
var apiRoutes = config_1.default.apiRoutes;
var SAVE_MESSAGE = 'Product has been saved';
var EditProductSpecs = mobx_react_1.observer(function (_a) {
    var product = _a.product;
    var _b = react_1.useState(false), open = _b[0], setOpen = _b[1];
    var _c = use_stores_1.useStores(), productSpecsStore = _c.productSpecsStore, productsStore = _c.productsStore, apiStore = _c.apiStore;
    var busyRoutes = apiStore.data.busyRoutes;
    var dialog = use_dialog_1.useDialog();
    var notification = use_notification_1.useNotification();
    react_1.useEffect(function () {
        if (productSpecsStore.data.length <= 0 &&
            !busyRoutes.includes(apiRoutes.PRODUCT_SPECS)) {
            api_1.default.getProductSpecs()
                .then(function (response) { return productSpecsStore.setData(response.data); })
                .catch(api_1.catchHandler);
        }
    }, []);
    var toggleOpen = function () {
        setOpen(!open);
    };
    var getSpecs = function () {
        return productSpecsStore.data.map(function (spec) {
            if (product.productSpecifications) {
                for (var _i = 0, _a = product.productSpecifications; _i < _a.length; _i++) {
                    var dataSpec = _a[_i];
                    if (spec.id === dataSpec.id) {
                        return __assign(__assign({}, spec), { live: false });
                    }
                }
            }
            return spec;
        });
    };
    var getSpecFromStore = function (id) {
        for (var _i = 0, _a = productSpecsStore.data; _i < _a.length; _i++) {
            var spec = _a[_i];
            if (spec.id === id)
                return spec;
        }
        return null;
    };
    var putSpecification = function (specification) {
        api_1.default.putProductSpec(product.id, specification.id)
            .then(function (response) {
            productsStore.editDataItem(response.data);
            notification({
                variant: Notification_1.NotificationVariants.SUCCESS,
                message: SAVE_MESSAGE
            });
        })
            .catch(api_1.catchHandler);
    };
    var addSpecHandler = function (productSpec) {
        setOpen(false);
        for (var _i = 0, _a = productSpecsStore.data; _i < _a.length; _i++) {
            var spec = _a[_i];
            if (spec.id === productSpec.id) {
                putSpecification(spec);
            }
        }
    };
    var removeSpecHandler = function (id) {
        dialog({
            variant: Dialog_1.DialogVariants.CONFIRMATION,
            title: 'Delete Product Specification',
            description: 'Are you sure you want to remove this specification?'
        })
            .then(function () {
            api_1.default.removeProductSpec(product.id, id)
                .then(function (response) {
                productsStore.editDataItem(response.data);
                notification({
                    variant: Notification_1.NotificationVariants.SUCCESS,
                    message: SAVE_MESSAGE
                });
            })
                .catch(api_1.catchHandler);
        });
    };
    var submitSpecHandler = function (value) {
        if (value.length >= 0) {
            setOpen(false);
            var newItem = {
                name: value
            };
            api_1.default.createProductSpec(newItem)
                .then(function (response) {
                productSpecsStore.addDataItem(response.data);
                putSpecification(response.data);
            })
                .catch(api_1.catchHandler);
        }
    };
    var putSpecificationItem = function (specificationItem) {
        api_1.default.putProductSpecItem(product.id, specificationItem.id)
            .then(function (response) {
            productsStore.editDataItem(response.data);
            notification({
                variant: Notification_1.NotificationVariants.SUCCESS,
                message: SAVE_MESSAGE
            });
        })
            .catch(api_1.catchHandler);
    };
    var addSpecItemHandler = function (specificationItem) {
        putSpecificationItem(specificationItem);
    };
    var removeSpecItemHandler = function (specItem) {
        api_1.default.removeProductSpecItem(product.id, specItem.id)
            .then(function (response) {
            productsStore.editDataItem(response.data);
            notification({
                variant: Notification_1.NotificationVariants.SUCCESS,
                message: SAVE_MESSAGE
            });
        })
            .catch(api_1.catchHandler);
    };
    var submitSpecItemHandler = function (productSpec, value) {
        var newItem = {
            productSpecificationId: productSpec.id,
            name: value
        };
        var targetSpec = {};
        for (var _i = 0, _a = productSpecsStore.data; _i < _a.length; _i++) {
            var storeSpec = _a[_i];
            if (storeSpec.id === productSpec.id)
                targetSpec = storeSpec;
        }
        api_1.default.createProductSpecItem(newItem)
            .then(function (response) {
            productSpecsStore.editDataItem(__assign(__assign({}, targetSpec), { productSpecificationItems: __spreadArrays(targetSpec.productSpecificationItems, [
                    response.data
                ]) }));
            putSpecificationItem(response.data);
        })
            .catch(api_1.catchHandler);
    };
    return (react_1.default.createElement("div", { className: 'edit-product__page edit-product-specs' },
        react_1.default.createElement("span", { className: 'title' }, "Product Specifications"),
        react_1.default.createElement("div", { className: 'help flex flex-row' },
            react_1.default.createElement("img", { src: help_icon_svg_1.default, alt: 'Help' }),
            react_1.default.createElement("p", null, "These specifications will help your customers to filter products in your shop, for example: materials or brand.")),
        product.productSpecifications &&
            product.productSpecifications.map(function (productSpec) { return (react_1.default.createElement(EditProductSpecsItem_1.default, { key: productSpec.id, productSpec: productSpec, storeSpec: getSpecFromStore(productSpec.id), onRemoveSpec: function () { return removeSpecHandler(productSpec.id); }, onAddSpecItem: function (specItem) { return addSpecItemHandler(specItem); }, onRemoveSpecItem: function (specItem) { return removeSpecItemHandler(specItem); }, onSubmitSpecItem: function (value) { return submitSpecItemHandler(productSpec, value); } })); }),
        !open &&
            react_1.default.createElement(AddButton_1.default, { label: 'Add new specification', onClick: toggleOpen }),
        open &&
            react_1.default.createElement("div", { className: 'edit-product__add-form form' },
                react_1.default.createElement("div", { className: 'edit-product__add-form__top flex flex-row flex-space-between' },
                    react_1.default.createElement("span", { className: 'title' }, "Add a product specification"),
                    react_1.default.createElement("button", { type: 'button', title: 'Close', "aria-label": 'close', className: 'edit-product-specs__form__close flex flex-column flex-center', onClick: toggleOpen },
                        react_1.default.createElement("img", { src: close_icon_svg_1.default, alt: 'Close' }))),
                react_1.default.createElement(SelectWithNewEntry_1.default, { value: null, label: 'Specification', data: getSpecs(), onChange: addSpecHandler, onSubmit: submitSpecHandler }))));
});
exports.default = EditProductSpecs;
